import { SET_STORES_FILTERS } from '../actions/filters';

const initialState = {
    search: '',
    enabled: 'true',
    type: [],
    from_created: '',
    to_created: ''
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_STORES_FILTERS:
            return {
                ...state,
                search: action.payload.search,
                enabled: action.payload.enabled,
                type: action.payload.type,
                from_created: action.payload.from_created,
                to_created: action.payload.to_created
            };
        default:
            return state;
    }
};
